<div class="dashboard-vehiculos">
  <app-dashboard-filtros titulo="Vehículos"></app-dashboard-filtros>

  @if (cargando) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  } @else {
    <!-- Stat cards -->
    <div class="stat-row dashboard-indicadores">
      @if (statCardTotal) {
        <app-stat-card
          [config]="statCardTotal"
          [formatAsNumber]="true"
          numberFormat="1.0-0"
        ></app-stat-card>
      }
      @if (statCardReportando) {
        <app-stat-card
          [config]="statCardReportando"
          [formatAsNumber]="true"
          numberFormat="1.0-0"
        ></app-stat-card>
      }
      @if (statCardEnMovimiento) {
        <app-stat-card
          [config]="statCardEnMovimiento"
          [formatAsNumber]="true"
          numberFormat="1.0-0"
        ></app-stat-card>
      }
      @if (statCardReglas) {
        <app-stat-card
          [config]="statCardReglas"
          [formatAsNumber]="true"
          numberFormat="1.0-0"
        >
          <div card-actions class="stat-card-actions">
            @if (puedeCrearRegla()) {
              <button irxBoton="principal" (click)="crearRegla()">
                <mat-icon>add</mat-icon>
                Crear regla
              </button>
            }
            @if (puedeVerEventos()) {
              <a
                irxBoton="principal"
                [routerLink]="['/main/administracion/config-evento-usuario']"
                [queryParams]="{ crear: 'Page' }"
              >
                <mat-icon>list</mat-icon>
                Ver listado
              </a>
            }
          </div>
        </app-stat-card>
      }
    </div>

    <!-- Tortas -->
    <div class="paneles-fila">
      @if (chartCardPorTipo) {
        <app-chart-card [config]="chartCardPorTipo"></app-chart-card>
      }
      @if (chartCardPorFuncion) {
        <app-chart-card [config]="chartCardPorFuncion"></app-chart-card>
      }
    </div>

    <!-- Consumo de combustible -->
    @if (chartCardConsumo) {
      <app-chart-card [config]="chartCardConsumo"></app-chart-card>
    }

    <!-- Informes de combustible -->
    <app-dashboard-panel
      titulo="Informes de combustible"
      icono="local_gas_station"
    >
      <app-informe-combustible></app-informe-combustible>
    </app-dashboard-panel>
  }
</div>
